import SockJS from "sockjs-client/dist/sockjs.min";
import { Client } from "@stomp/stompjs";

let stompClient = null;

export function connectNotificationSocket(onNotificationReceived) {
  const token = document.querySelector('meta[name="_csrf"]');
  const header = document.querySelector('meta[name="_csrf_header"]');

  try {
    const socket = new SockJS("/ws", null, {
      transports: ["websocket"],
    });

    stompClient = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,
      debug: (str) => console.log("[WebSocket]", str),
      connectHeaders:
        header && token
          ? {
              [header.content]: token.content,
            }
          : {},
      onConnect: () => {
        console.log("[WebSocket] Verbunden.");

        stompClient.subscribe("/user/queue/notifications", (message) => {
          try {
            const notification = JSON.parse(message.body);
            onNotificationReceived(notification);
            console.log("[WebSocket] Nachricht empfangen:", notification);
          } catch (e) {
            console.error("[WebSocket] Fehler beim Verarbeiten der Nachricht:", e);
          }
        });
      },
      onStompError: (frame) => {
        console.error("[WebSocket] Fehler:", frame.headers["message"]);
      },
      onWebSocketError: (event) => {
        console.error("[WebSocket] WebSocket-Fehler:", event);
      },
    });

    stompClient.activate();
  } catch (error) {
    console.error("[WebSocket] Fehler beim Verbinden:", error);
  }
}

export function disconnectNotificationSocket() {
  if (stompClient) {
    stompClient.deactivate();
    console.log("[WebSocket] Verbindung getrennt.");
  }
}
